import appConstants from '../../constants';

const SERVICE_NAME = 'fetchUserCountry';
const SERVICE_URL = `${appConstants.SERVICE_BASE_URL}${appConstants.SERVICE_REQUEST_FETCH_USER_COUNTRY_URL}`;

export default async function fetchUserCountry(latitude, longitude) {
  if (!!latitude && !!longitude) {
    try {
      const response =
        await fetch(
          `${SERVICE_URL}?lat=${latitude}&lng=${longitude}`,
          appConstants.SERVICE_REQUEST_FETCH_USER_COUNTRY_CONFIG
        );
      const text = await response.text();
      if (text === 'Not Found') {
        const errorMessage = `Country "Not Found" from coordinates (lat:${latitude}, lng: ${longitude}).`;
        console.warn(`${SERVICE_NAME} >> ${errorMessage}`);
        return {
          hasError: true,
          errorMessage: errorMessage,
          countryNames: null
        }
      }
      const data = JSON.parse(text);
      if (!!data &&
        'shortName' in data &&
        'longName' in data) {
        return {
          hasError: false,
          errorMessage: null,
          countryNames: data
        };
      }
      else {
        const errorMessage = 'Country shortName and longName are missing from the returned country object.';
        console.warn(`${SERVICE_NAME} >> ${errorMessage}`);
        return {
          hasError: true,
          errorMessage: errorMessage,
          countryNames: null
        }
      }
    }
    catch(exception) {
      console.warn(`${SERVICE_NAME} >> ${exception.message}`);
      return {
        hasError: true,
        errorMessage: exception.message,
        countryNames: null
      }
    }
  }
  else {
    const errorMessage = 'Longitude and latitude coordinates are required and none were provided.';
    console.error(`${SERVICE_NAME} >> ${errorMessage}`);
    return {
      hasError: true,
      errorMessage: errorMessage,
      countryNames: null
    }
  }
}

